import React from 'react';
import { AccessTimeOutlined, LocationOnOutlined } from '@mui/icons-material';

const AdvancedPathway = () => {
    const advancedPath = [
        {
            label: 'Documentaire avancé',
            description: 'Vidéo "Traitement des images radar" du CNES.',
            duration: 'Variable',
            location: 'Onglet Documentaires généraux',
            bgColor: 'bg-purple-50'
        },
        {
            label: 'Approfondissement du cours',
            description: 'Prise de connaissance des chapitres suivants du cours rédigé pour pouvoir le consulter en s\'appuyant sur le plan.',
            duration: 'Variable',
            location: 'Onglet Cours rédigé',
            bgColor: 'bg-fuchsia-50'
        },
        {
            label: 'Comparaison des cours ESA et ENSG',
            description: 'Analyse comparative des explications communes aux deux cours. Création de liens avec le cours rédigé et identification des notions difficiles.',
            duration: 'Variable',
            location: 'Onglet cours RADAR de l\'ESA et cours ENSG',
            bgColor: 'bg-purple-50'
        },
        {
            label: 'Exercices pratiques',
            description: 'Isolation et résolution des exercices du cours ENSG, avec réflexion avant de consulter les solutions.',
            duration: 'Variable',
            location: 'Cours ENSG',
            bgColor: 'bg-fuchsia-50'
        },
        {
            label: 'École d\'été avancée',
            description: 'Power points des deuxième et troisième jours de l\'École d\'été de Fianarantsoa.',
            duration: 'Variable',
            location: 'Onglet École d\'été Fianarantsoa avril 2024',
            bgColor: 'bg-purple-50'
        },
        {
            label: 'Révision des bases',
            description: 'Reprise du Power point annoté de Douala pour réviser les bases.',
            duration: 'Variable',
            location: 'Power point annoté de Douala',
            bgColor: 'bg-fuchsia-50'
        },
        {
            label: 'MOOC multilingue',
            description: 'Suivi des cours de l\'onglet MOOC multilingue (contenu plus difficile).',
            duration: 'Variable',
            location: 'Onglet MOOC multilingue',
            bgColor: 'bg-purple-50'
        },
        {
            label: 'Articles scientifiques',
            description: 'Lecture des articles du numéro spécial RADAR de l\'onglet RFPT.',
            duration: 'Variable',
            location: 'Onglet RFPT',
            bgColor: 'bg-fuchsia-50'
        }
    ];

    return (
        <div className="mb-8">
            <div className="flex justify-center text-center items-center mb-6">
                <div>
                    <h2 className="text-2xl font-bold text-gray-900">Parcours pour renforcer les connaissances</h2>
                    <p className="text-gray-600">Durée variable selon les besoins, pour approfondir et maîtriser les concepts avancés</p>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {advancedPath.map((step, index) => (
                    <div key={index} className={`rounded-lg shadow-md overflow-hidden border border-gray-200 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 ${step.bgColor}`}>
                        {/* Card header with step number */}
                        <div className="bg-purple-600 h-2 w-full"></div>

                        <div className="p-5">
                            {/* Number badge */}
                            <div className="flex justify-between items-center mb-3">
                                <div className="bg-white text-purple-600 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold border-2 border-purple-600">
                                    {index + 1}
                                </div>
                                {/* Number badge  <ArrowForwardIos className="text-blue-600 w-4 h-4" />*/}
                            </div>

                            {/* Content */}
                            <h3 className="text-lg font-semibold text-gray-900 mb-2">
                                {step.label}
                            </h3>
                            <p className="text-gray-700 mb-4 h-24 overflow-y-auto text-sm">{step.description}</p>

                            {/* Footer with metadata */}
                            <div className="pt-2 border-t border-gray-200">
                                <div className="flex flex-wrap gap-2">
                                    <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-purple-100 text-purple-800">
                                        <AccessTimeOutlined className="w-3.5 h-3.5 mr-1"/>
                                        {step.duration}
                                    </span>
                                    <span className="inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-800">
                                        <LocationOnOutlined className="w-3.5 h-3.5 mr-1"/>
                                        {step.location}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            <div className="mt-6 p-4 bg-purple-50 text-purple-800 rounded-md text-sm border border-purple-200">
                <p className="font-medium">Prévoir de discuter avec les autres étudiants tout au long de cet approfondissement. La durée de ce parcours est à adapter selon vos besoins spécifiques.</p>
            </div>
        </div>
    );
};

export default AdvancedPathway;